module.exports = __webpack_public_path__ + "static/img/arrow_right_over.e8efc54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/arrow_right_over.png
// module id = hznu
// module chunks = 10